type EntityViewPair = { entityName: string; viewName: string }

/**
 * Parses a sitemap view item and produces entity/view pairs
 * for all the views declared in the ViewName attribute in the model. The accepted formats are:
 * - "VIEW_NAME,VIEW_NAME,..."
 * - "ENTITY_NAME:VIEW_NAME,ENTITY_NAME:VIEW_NAME,..."
 *
 * You can, of course, mix and match these two formats.
 */
export function parseSitemapViews(baseEntity: string, views: string) {
  const splitted = views.split(',')
  const res: EntityViewPair[] = []
  splitted.forEach((s) => {
    const tuple = s.split(':')
    if (tuple.length > 1) {
      res.push({
        entityName: tuple[0],
        viewName: tuple[1],
      })
    } else {
      res.push({
        entityName: baseEntity,
        viewName: s,
      })
    }
  })
  return res
}

const serialize = ({ entityName, viewName }: EntityViewPair) => `${entityName}:${viewName}`

export function sameSitemapViews(pairs1: EntityViewPair[], pairs2: EntityViewPair[]) {
  if (pairs1.length !== pairs2.length) {
    return false
  }
  const serialized1 = pairs1.map(serialize)
  const serialized2 = pairs2.map(serialize)
  const set = new Set(serialized2)
  return serialized1.every((s) => set.has(s))
}
